import request from '@/utils/request';

function transformItem2Dto(item) {
  const dto = {
    orderID: item.id,
    ...item
  };
  delete dto.orderedAt;
  delete dto.createdAt;
  delete dto.id;
  return dto;
}

export function createOrder(order) {
  const url = `order/createOrder`;
  return request({
    data: order,
    method: 'post',
    url: url,
    timeout: 900000
  });
}
export const storeExtensions = {
  actions: {
    createOrder({ dispatch }, order) {
      return new Promise((resolve, reject) =>
        createOrder(order)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
export const apiOverrides = { transformItem2Dto };
